import { IResourceComponentsProps } from "@pankod/refine-core";
import { MappingContract } from "./mapping";

export const ContractList: React.FC<IResourceComponentsProps> = () => {
  return <MappingContract mode="Remove" />;
};
